import { Component, OnInit, ViewChild } from "@angular/core";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import { Dictionary } from "src/app/store/models/common_types";
import { ActivatedRoute, Router } from "@angular/router";
import { ReportingGridWrapperComponent } from "../reporting-grid-wrapper/reporting-grid-wrapper.component";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { Subscription } from "rxjs";
import { AppService } from "src/app/app.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ReportingPagesService } from "../reporting-pages.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { VAIconRegistryService, externalLink } from "@va/core-library/icons";
@Component({
  selector: "app-reporting-broker",
  templateUrl: "./reporting-broker.component.html",
  styleUrls: ["./reporting-broker.component.scss"],
  host: { class: "broker-page-component" },
})
export class ReportingBrokerComponent implements OnInit {
  showSearch = true;
  showGridFilters: boolean;
  brokerId = "";
  brokerName: string;
  disclosureData: Array<any>;
  imgUrl: string;
  legacyDomain: string = window.caUrl;
  page: string;
  coveragestatusList: Array<any> = [];
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
    setWidth: boolean;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  globalSearchVal: string;
  columnList: Array<any>;
  columnFields: Array<any>;
  columnsData: Array<any>;
  widthConfig: Array<any>;
  storeSub: Subscription;
  isDataSet: boolean;
  isSellside: boolean;
  isViewModalVisible = false;
  disclosureUrl: SafeUrl;
  @ViewChild(ReportingGridWrapperComponent)
  gridWrapperComp: ReportingGridWrapperComponent;
  constructor(
    private dataService: ReportingPagesDataService,
    private route: ActivatedRoute,
    private appService: AppService,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>,
    private service: ReportingPagesService,
    private message: NzMessageService,
    private router: Router,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
      setWidth: true,
    };
    this.isDataSet = false;
    this.coveragestatusList = this.dataService.getCoverageStatusValue();
    this.iconRegistry.registerIcons([externalLink]);
  }

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.globalSearchVal = "";
      const urlArr = window.location.pathname.split("/");
      this.brokerId = urlArr[urlArr.length - 1];
      this.isDataSet = false;
      this.dataService
        .getBrokerColumnMetaInfo(this.brokerId)
        .subscribe((res) => {
          if (res.status === "error") {
            //error encountered redirect to home page
            this.message.error(res.message, {
              nzDuration: 2000,
            });
            setTimeout(() => {
              this.router.navigateByUrl("/home");
            }, 2000);
            throw new Error(res.message);
          }
          this.brokerName = res.broker_name;
          this.disclosureData = res.disclosure;
          this.imgUrl = `${this.legacyDomain}/api/get_broker_logo?shortname=${this.brokerId}.png`;
          this.exportKey = `BROKER_PAGE_${this.brokerId}`;
          if (!this.isSellside) {
            res.columns = res.columns.filter((val) => val !== "views");
          }
          this.columnList = res.columns.map((val) => {
            let field = val;
            switch (val) {
              case "sector":
                field = "sectorname";
                break;
              case "industry":
                field = "industryname";
                break;
              case "size":
                field = "filesize";
                break;
              case "In VA Consensus?":
                field = "inconsensus";
                break;
              case "Coverage Status":
                field = "coveragestatus";
                break;
              default:
                break;
            }
            return field;
          });
          this.columnDataChange();
        });

      this.page = "broker";
      this.gridUrl = `api/brokeranalystdata?source=${this.brokerId}&`;
      this.service.logUserOnRedirection("BROKER_PAGE", {
        VALUE: this.brokerId,
      });
      this.store.dispatch(new GlobalSubheaderActions.SubheaderChanged());
    });
    this.columnFields = [
      {
        field: "analyst",
        renderer: "link",
      },
      {
        field: "ticker",
        renderer: "link",
      },
      {
        field: "companyname",
        renderer: "link",
      },
      {
        field: "country",
        renderer: null,
      },
      {
        field: "sectorname",
        renderer: "link",
      },
      {
        field: "industryname",
        renderer: "link",
      },
      {
        field: "peers",
        renderer: null,
      },
      {
        field: "modeldate",
        renderer: null,
      },
      {
        field: "filesize",
        renderer: "report-model-link",
      },
      {
        field: "inconsensus",
        renderer: null,
      },
      {
        field: "coveragestatus",
        renderer: null,
      },
      {
        field: "views",
        renderer: "report-view-link",
      },
    ];
    this.columnsData = [
      {
        children: 1,
        header: "Analyst",
        sortKey: "analyst",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Ticker",
        sortKey: "ticker",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Company",
        sortKey: "companyname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Country",
        sortKey: "country",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Sector",
        sortKey: "sectorname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Industry",
        sortKey: "industryname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Peers",
        sortKey: "peers",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Model Date",
        sortKey: "modeldate",
        showSort: true,
        showFilter: false,
      },
      {
        children: 1,
        header: "Model",
        sortKey: "filesize",
        showSort: false,
        showFilter: false,
      },
      {
        children: 1,
        header: "In VA Consensus?",
        sortKey: "inconsensus",
        showSort: false,
        showFilter: true,
        filterType: "select",
        filterSelectValues: [
          { val: "", display: "[All]" },
          { val: "yes", display: "Yes" },
          { val: "no", display: "No" },
          { val: "not current", display: "Not Current" },
        ],
        currentValue: "",
      },
      {
        children: 1,
        header: "Coverage Status",
        sortKey: "coveragestatus",
        showSort: false,
        showFilter: true,
        filterType: "select",
        filterSelectValues: this.coveragestatusList,
        currentValue: "",
      },
      {
        children: 1,
        header: "Views",
        sortKey: "views",
        showSort: false,
        showFilter: false,
      },
    ];
    this.widthConfig = [
      "200px", //analyst
      "120px", //ticker
      "220px", //companyname
      "120px", //country
      "170px", //sectorname
      "180px", //industryname
      "120px", //peers
      "120px", //modeldate
      "100px", //filesize
      "120px", //inconsensus
      "150px", //Contenttype
      "280px", //views
    ];

    this.storeSub = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (Object.keys(data).length === 0 && data.constructor === Object) {
          return;
        }
        this.isSellside = data.isSellside;
        if (this.isSellside) {
          this.columnList.push("views");
        } else if (this.columnList.includes("views")) {
          this.columnList.pop();
        }
        this.columnDataChange();
      });
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
  }

  onSearch(val) {
    this.globalSearchVal = val;
  }

  onReloadGrid() {
    this.gridWrapperComp.gridReload();
  }
  columnDataChange() {
    let columnFields = [];
    const columnData = [],
      colWidths = [];
    for (let index = 0; index < this.columnList.length; index++) {
      const element = this.columnList[index];
      columnFields.push(
        this.columnFields.filter((val, i) => {
          if (val.field === element) {
            columnData.push(this.columnsData[i]);
            colWidths.push(this.widthConfig[i]);
            return val;
          }
          return null;
        })[0],
      );
    }
    columnFields = columnFields.filter(
      (val) => val !== null && val !== undefined,
    );
    this.sortKey = "companyname";
    this.columns = {
      columnFields: columnFields,
      columnsData: [columnData],
      widthConfig: colWidths,
      setWidth: true,
    };
    this.exportColumns = columnData.map((d) => {
      return d.sortKey;
    });
    this.isDataSet = true;
  }
  showDisclosure(url, external) {
    const extras = {
      UTCTIME: new Date().toUTCString(),
      URL: location.href,
    };

    this.appService.logUserAction(
      {},
      "",
      "",
      "DISCLOSURE_BROKERPAGE",
      extras,
      "",
      "",
    );
    if (external) {
      const disclosureUrl =
        url.includes("https://") || url.includes("http://")
          ? url
          : `${window.caUrl}${url}`;
      window.open(disclosureUrl, "_blank");
    } else {
      this.disclosureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        location.origin + url,
      );
      this.isViewModalVisible = true;
    }
  }
  handleCancel() {
    this.isViewModalVisible = false;
  }
  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }
}
